<template>
  <div class="cardLiveSkeleton">
    <div class="cardLiveSkeleton__bannerImage skeletonLoading" />

    <div class="cardLiveSkeleton__content">
      <div class="flex flex-row justify-around">
        <div class="relative flex flex-col justify-center items-center">
          <BaseLogo />
          <div class="cardLiveSkeleton__teamName skeletonLoading h-4 w-24 mt-2" />
        </div>
        <div class="text-caption-bold text-secondary pt-4">
          VS
        </div>
        <div class="relative flex flex-col justify-center items-center">
          <BaseLogo />
          <div class="cardLiveSkeleton__teamName skeletonLoading h-4 w-24 mt-2" />
        </div>
      </div>
      <div class="mt-4 flex justify-between">
        <div class="cardLiveSkeleton__title skeletonLoading w-48 mr-2" />
        <div class="cardLiveSkeleton__sportTypeIcon skeletonLoading" />
      </div>
    </div>

    <div class="cardLiveSkeleton__lock skeletonLoading" />
  </div>
</template>

<style lang="scss">
.cardLiveSkeleton {
  @apply flex flex-col max-w-full
  overflow-hidden cursor-wait
  transition duration-100
  hover:shadow-2xl;

  background-color: var(--base-card-bgColor);
  border-radius: var(--base-border-radius);

  .cardLiveSkeleton__bannerImage {
    @apply w-full object-cover rounded-t-sm h-20;
  }

  .cardLiveSkeleton__content {
    @apply relative p-3 pt-8
    max-w-full flex-grow-0
    flex flex-col justify-between;
  }

  .cardLiveSkeleton__teamName {
    @apply text-base font-medium truncate;

    color: var(--base-text-color);
  }

  .cardLiveSkeleton__title {
    @apply text-xs font-medium truncate;

    color: var(--base-secondary-color);
  }

  .cardLiveSkeleton__sportTypeIcon {
    @apply w-4 h-4 rounded-full;
  }

  .cardLiveSkeleton__lock {
    @apply w-full h-4 rounded-none;
  }
}
</style>
